import {
  getDiagnosticos,
} from "../../../helpers/backend_helper";
import {
  apiError,
  diagnosticosSuccess,
  reset_diagnostico_flag,
} from "./reducer";

export const getdiagnosticos = () => async (dispatch) => {
  try {
    console.log('🚀 Llamando a getDiagnosticos()...');
    const response = await getDiagnosticos();
    console.log('📥 Respuesta recibida:', response);

    if (response && response.data) {
      const serializableData = {
        data: response.data,
        message: response.message,
        status: response.status,
      };
      console.log('✅ Despachando diagnosticosSuccess con:', serializableData);
      dispatch(diagnosticosSuccess(serializableData));
    } else {
      console.warn('⚠️ Respuesta sin datos:', response);
    }
  } catch (error) {
    console.error('❌ Error en getdiagnosticos:', error);
    dispatch(apiError(error));
  } 
};


export const resetDiagnosticoFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_diagnostico_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
